import { createIcon } from '../icon'
import ArrowIconRight from '../svg/ArrowIconRight'

export const ArrowIconRightDefault = createIcon(ArrowIconRight)
